import { useTranslation } from 'react-i18next';
import { Card, CardBody } from 'reactstrap';
import dayjs from 'dayjs';

import { TrapData } from 'api/periodReports/type';

const TrapsDataElement: React.FC<{ data: TrapData }> = ({ data }) => {
  const { t } = useTranslation();
  return (
    <Card className="card shadow-hover">
      <a
        target="_blank"
        href={`${process.env.REACT_APP_BASE_DJANGO_URL}/trap/info/${data.serial_number}`}
        rel="noreferrer"
      >
        <CardBody>
          <div className="d-lg-flex align-items-center">
            {/* Column 1 */}
            <div className="col-lg-1 text-center">
              <div>
                <i title="Trap which was out of signal" className="ri-signal-tower-fill text-warning fs-3" />
              </div>
            </div>

            {/* Column 2 */}
            <div className="col-lg-1">
              <div className="ms-4">
                <h5 className="fs-16 text-center mb-2">{data.trap_number}</h5>
                <p className="text-muted text-center mb-0">№</p>
              </div>
            </div>

            {/* Column 3 */}
            <div className="col-lg-2">
              <div className="ms-4">
                <h5 className="fs-16 text-center mb-2">{data.serial_number}</h5>
                <p className="text-muted text-center mb-0">
                  {t('TrapsDataList.accordion.accordion-inner.serial-number')}
                </p>
              </div>
            </div>

            {/* Column 4 */}
            <div className="col-lg-2">
              <div className="ms-4">
                <h5 className="fs-16 text-center mb-2">
                  {dayjs(data.offline_start).format('YYYY-MM-DD\xa0\xa0\xa0HH:mm')}
                </h5>
                <p className="text-muted text-center mb-0">
                  {t('TrapsDataList.accordion.accordion-inner.last-monitoring-msg')}
                </p>
              </div>
            </div>

            {/* Column 4 */}
            <div className="col-lg-2">
              <div className="ms-4">
                <h5 className="fs-16 text-center mb-2">
                  {dayjs(data.offline_end).format('YYYY-MM-DD\xa0\xa0\xa0HH:mm')}
                </h5>
                <p className="text-muted text-center mb-0">
                  {t('TrapsDataList.accordion.accordion-inner.next-recieved-msg')}
                </p>
              </div>
            </div>

            {/* Column 4 */}
            <div className="col-lg-2">
              <div className="ms-4">
                <h5 className="fs-16 text-center mb-2">{data.time_range}</h5>
                <p className="text-muted text-center mb-0">{t('TrapsDataList.accordion.accordion-inner.time-range')}</p>
              </div>
            </div>

            {/* Column 4 */}
            <div className="col-lg-2">
              <div className="ms-4">
                <h5 className="fs-16 text-center mb-2">{data.lost_msgs}</h5>
                <p className="text-muted text-center mb-0">{t('TrapsDataList.accordion.accordion-inner.lost-msgs')}</p>
              </div>
            </div>
          </div>
        </CardBody>
      </a>
    </Card>
  );
};

export default TrapsDataElement;
